import { ModelBase } from 'store/model-base';

export class CmsBillingLanding extends ModelBase {
    public static storeName: string = 'cmsBillingLanding';

    public pastDue: CmsBillingPastDueBridge;
    public nextPayment: CmsBillingLandingNextPayment;
    public transactions: CmsBillingLandingTransactions;
    public currentCycle: CmsBillingLandingCurrentCycle;
}
